import React from 'react';
import { Card, Stack, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface OverduePMsCardProps {
  value: number;
}

const OverduePMsCard: React.FC<OverduePMsCardProps> = ({ value }) => {
  return (
    <Card sx={{ flex: 1, minWidth: { xs: '100%', sm: 200 }, border: '1px solid #e2e8f0' }} elevation={0}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
        <Stack spacing={0.5}>
          <Typography variant="body2" sx={{ color: '#64748b' }}>Overdue</Typography>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>{value}</Typography>
        </Stack>
        <Box sx={{
          width: 48, height: 48, borderRadius: '50%',
          backgroundColor: '#f59e0b15', display: 'flex',
          alignItems: 'center', justifyContent: 'center'
        }}>
          <WarningAmberIcon sx={{ color: '#f59e0b', fontSize: 28 }} />
        </Box>
      </Stack>
    </Card>
  );
};

export default OverduePMsCard;
